import { useState, useEffect, Fragment } from "react";
import {
  getCrmTeklifler, getCrmTeklifDetay, getCrmTeklifNetsisDetay, addCrmTeklif, updateCrmTeklif, updateCrmTeklifDurum,
  deleteCrmTeklif, sendCrmTeklifToNetsis, getCrmFirmalar, getCrmKisiler, getCrmFirsatlar, getCrmStoklar, getCrmPlasiyerler,
  getCrmTeklifPdf, getCrmTeklifNetsisPdf,
} from "../services/api";

const DURUMLAR = ["Taslak", "Gonderildi", "Kabul", "Red"];
const DURUM_RENK = { Taslak: "#94a3b8", Gonderildi: "#60a5fa", Kabul: "#34d399", Red: "#f87171" };

const today = new Date().toISOString().slice(0, 10);
const EMPTY_HEADER = { firma_id: "", kisi_id: "", firsat_id: "", tarih: today, gecerlilik_tarihi: "", notlar: "", sorumlu_kullanici: "" };
const EMPTY_KALEM = { stok_kodu: "", aciklama: "", miktar: 1, birim_fiyat: 0, iskonto_orani: 0, kdv_orani: 20 };

const fmt = (n) => n == null ? "-" : Number(n).toLocaleString("tr-TR", { minimumFractionDigits: 2 }) + " TL";

const card = { background: "var(--bg-card-alt)", border: "1px solid var(--accent-bg)", borderRadius: 10, padding: 20 };
const th   = { padding: "10px 14px", textAlign: "left", fontWeight: 600, fontSize: 12, color: "var(--text-muted)", borderBottom: "1px solid var(--border-hairline)", textTransform: "uppercase", letterSpacing: ".05em" };
const td   = { padding: "11px 14px", fontSize: 13, color: "var(--text-primary)", borderBottom: "1px solid var(--border-hairline)" };
const inp  = { background: "var(--bg-card)", border: "1px solid var(--border)", borderRadius: 7, padding: "8px 11px", color: "var(--text-primary)", fontSize: 13, outline: "none", width: "100%", boxSizing: "border-box" };
const btn  = (bg, color) => ({ background: bg, color, border: "none", borderRadius: 7, padding: "9px 18px", fontSize: 13, fontWeight: 600, cursor: "pointer" });

function StokSecici({ stoklar, onSelect, onClose }) {
  const [search, setSearch] = useState("");

  const filtered = stoklar.filter((s) =>
    (s.StokAdi || "").toLowerCase().includes(search.toLowerCase()) ||
    (s.STOK_KODU || "").toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)",
      display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000,
    }}>
      <div style={{
        background: "var(--bg-sidebar)", border: "1px solid var(--accent-bg)", borderRadius: 12,
        width: 580, maxHeight: "70vh", display: "flex", flexDirection: "column",
        boxShadow: "0 25px 50px rgba(0,0,0,0.5)",
      }}>
        <div style={{ padding: "16px 20px", borderBottom: "1px solid var(--border-hairline)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ fontSize: 15, fontWeight: 600, color: "var(--accent-text)" }}>Stok Sec</div>
          <button onClick={onClose} style={{ background: "none", border: "none", color: "var(--text-muted)", fontSize: 20, cursor: "pointer", lineHeight: 1 }}>x</button>
        </div>
        <div style={{ padding: "12px 20px", borderBottom: "1px solid var(--border-hairline)" }}>
          <input
            autoFocus
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Stok kodu veya adi ara..."
            style={{
              width: "100%", background: "var(--bg-card)", border: "1px solid var(--border)",
              borderRadius: 7, padding: "8px 12px", color: "var(--text-primary)", fontSize: 13,
              outline: "none", boxSizing: "border-box",
            }}
          />
        </div>
        <div style={{ overflowY: "auto", flex: 1 }}>
          {filtered.length === 0 && <div style={{ padding: 32, textAlign: "center", color: "var(--text-faint)", fontSize: 13 }}>Sonuc bulunamadi.</div>}
          {filtered.map((s, i) => (
            <div key={i} onClick={() => onSelect(s)}
              style={{ padding: "10px 20px", cursor: "pointer", borderBottom: "1px solid var(--border-hairline)", display: "flex", gap: 16, alignItems: "center" }}
              onMouseEnter={(e) => e.currentTarget.style.background = "var(--bg-card-alt)"}
              onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}>
              <span style={{ fontSize: 12, fontWeight: 600, color: "#60a5fa", minWidth: 90 }}>{s.STOK_KODU}</span>
              <span style={{ fontSize: 13, color: "var(--text-primary)", flex: 1 }}>{s.StokAdi}</span>
              <span style={{ fontSize: 12, color: "#34d399" }}>{fmt(s.SatisFiyati)}</span>
            </div>
          ))}
        </div>
        <div style={{ padding: "10px 20px", borderTop: "1px solid var(--border-hairline)", fontSize: 12, color: "var(--text-faint)" }}>
          {filtered.length} kayit listeleniyor
        </div>
      </div>
    </div>
  );
}

function kalemTutar(k) {
  const miktar = parseFloat(k.miktar) || 0;
  const fiyat = parseFloat(k.birim_fiyat) || 0;
  const iskonto = parseFloat(k.iskonto_orani) || 0;
  return miktar * fiyat * (1 - iskonto / 100);
}
function kalemKdvli(k) {
  const kdv = parseFloat(k.kdv_orani) || 0;
  return kalemTutar(k) * (1 + kdv / 100);
}

export default function CrmTeklifler() {
  const [teklifler, setTeklifler] = useState([]);
  const [firmalar, setFirmalar] = useState([]);
  const [kisiler, setKisiler] = useState([]);
  const [firsatlar, setFirsatlar] = useState([]);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);
  const [header, setHeader] = useState(EMPTY_HEADER);
  const [kalemler, setKalemler] = useState([{ ...EMPTY_KALEM }]);
  const [editId, setEditId] = useState(null);
  const [netsisLoadingId, setNetsisLoadingId] = useState(null);
  const [stoklar, setStoklar] = useState([]);
  const [stokModalIdx, setStokModalIdx] = useState(null);
  const [plasiyerler, setPlasiyerler] = useState([]);
  const [expandedKey, setExpandedKey] = useState(null);
  const [expandedKalemler, setExpandedKalemler] = useState([]);
  const [expandedLoading, setExpandedLoading] = useState(false);

  useEffect(() => {
    getCrmFirmalar().then((r) => setFirmalar(r.data)).catch(() => {});
    getCrmFirsatlar().then((r) => setFirsatlar(r.data)).catch(() => {});
    getCrmStoklar().then((r) => setStoklar(r.data)).catch(() => {});
    getCrmPlasiyerler().then((r) => setPlasiyerler(r.data)).catch(() => {});
    load();
  }, []);

  useEffect(() => {
    if (!header.firma_id) { setKisiler([]); return; }
    getCrmKisiler({ firma_id: header.firma_id }).then((r) => setKisiler(r.data)).catch(() => {});
  }, [header.firma_id]);

  async function load() {
    setLoading(true);
    try { setTeklifler((await getCrmTeklifler()).data); }
    catch { flash("Yuklenemedi", "error"); }
    finally { setLoading(false); }
  }

  function flash(text, type = "success") {
    setMsg({ text, type });
    setTimeout(() => setMsg(null), 4000);
  }

  function resetForm() {
    setEditId(null);
    setHeader(EMPTY_HEADER);
    setKalemler([{ ...EMPTY_KALEM }]);
  }

  function updateKalem(idx, field, value) {
    setKalemler((rows) => rows.map((r, i) => (i === idx ? { ...r, [field]: value } : r)));
  }
  function addKalemRow() {
    setKalemler((rows) => [...rows, { ...EMPTY_KALEM }]);
  }
  function removeKalemRow(idx) {
    setKalemler((rows) => (rows.length > 1 ? rows.filter((_, i) => i !== idx) : rows));
  }

  function handleStokSecildi(stok) {
    setKalemler((rows) => rows.map((r, i) => (i === stokModalIdx ? {
      ...r,
      stok_kodu: stok.STOK_KODU,
      aciklama: r.aciklama.trim() ? r.aciklama : stok.StokAdi,
      birim_fiyat: stok.SatisFiyati ?? r.birim_fiyat,
      kdv_orani: stok.KdvOrani ?? r.kdv_orani,
    } : r)));
    setStokModalIdx(null);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!header.firma_id) { flash("Once bir firma secin", "error"); return; }
    const gecerliKalemler = kalemler.filter((k) => k.aciklama.trim());
    if (gecerliKalemler.length === 0) { flash("En az bir kalem girin", "error"); return; }
    const payload = {
      ...header,
      kisi_id: header.kisi_id ? Number(header.kisi_id) : null,
      firsat_id: header.firsat_id ? Number(header.firsat_id) : null,
      gecerlilik_tarihi: header.gecerlilik_tarihi || null,
      kalemler: gecerliKalemler.map((k) => ({
        stok_kodu: k.stok_kodu,
        aciklama: k.aciklama,
        miktar: parseFloat(k.miktar) || 0,
        birim_fiyat: parseFloat(k.birim_fiyat) || 0,
        iskonto_orani: parseFloat(k.iskonto_orani) || 0,
        kdv_orani: parseFloat(k.kdv_orani) || 0,
      })),
    };
    try {
      if (editId) {
        await updateCrmTeklif(editId, payload);
        flash("Teklif guncellendi");
      } else {
        const res = await addCrmTeklif(payload);
        flash(`Teklif eklendi (${res.data.id})`);
      }
      resetForm();
      load();
    } catch (err) {
      flash(err.response?.data?.detail || "Hata", "error");
    }
  }

  async function handleEdit(t) {
    try {
      const res = await getCrmTeklifDetay(t.ID);
      const h = res.data.header;
      setEditId(t.ID);
      setHeader({
        firma_id: h.FirmaID || "", kisi_id: h.KisiID || "", firsat_id: h.FirsatID || "",
        tarih: h.Tarih ? String(h.Tarih).slice(0, 10) : today,
        gecerlilik_tarihi: h.GecerlilikTarihi ? String(h.GecerlilikTarihi).slice(0, 10) : "",
        notlar: h.Notlar || "", sorumlu_kullanici: h.SorumluKullanici || "",
      });
      setKalemler(res.data.kalemler.map((k) => ({
        stok_kodu: k.StokKodu || "", aciklama: k.Aciklama || "",
        miktar: k.Miktar, birim_fiyat: k.BirimFiyat, iskonto_orani: k.IskontoOrani, kdv_orani: k.KdvOrani,
      })));
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch {
      flash("Teklif yuklenemedi", "error");
    }
  }

  async function handleDurumChange(id, durum) {
    try {
      await updateCrmTeklifDurum(id, durum);
      load();
    } catch { flash("Guncellenemedi", "error"); }
  }

  async function handleDelete(id, teklifNo) {
    if (!window.confirm(`"${teklifNo}" silinsin mi?`)) return;
    try {
      await deleteCrmTeklif(id);
      flash("Silindi");
      load();
    } catch (err) {
      flash(err.response?.data?.detail || "Silinemedi", "error");
    }
  }

  async function handlePrint(t) {
    try {
      const res = t.Kaynak === "CRM" ? await getCrmTeklifPdf(t.ID) : await getCrmTeklifNetsisPdf(t.NetsisFatirsNo);
      const blobUrl = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = `teklif-${t.TeklifNo}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
    } catch {
      flash("PDF olusturulamadi", "error");
    }
  }

  async function handleNetsisGonder(id, teklifNo) {
    if (!window.confirm(
      `"${teklifNo}" Netsis'in TBLTEKLIFMAS/TBLTEKLIFTRA tablolarina kalici olarak yazilacak. Bu islem geri alinamaz. Devam edilsin mi?`
    )) return;
    setNetsisLoadingId(id);
    try {
      const res = await sendCrmTeklifToNetsis(id);
      flash(`Netsis'e gonderildi: ${res.data.fatirs_no}`);
      load();
    } catch (err) {
      flash(err.response?.data?.detail || "Netsis'e gonderilemedi", "error");
    } finally {
      setNetsisLoadingId(null);
    }
  }

  async function handleToggleExpand(t) {
    const key = t.ID ?? t.NetsisFatirsNo;
    if (expandedKey === key) { setExpandedKey(null); return; }
    setExpandedKey(key);
    setExpandedLoading(true);
    setExpandedKalemler([]);
    try {
      const res = t.Kaynak === "CRM"
        ? await getCrmTeklifDetay(t.ID)
        : await getCrmTeklifNetsisDetay(t.NetsisFatirsNo);
      setExpandedKalemler(res.data.kalemler);
    } catch {
      flash("Kalemler yuklenemedi", "error");
    } finally {
      setExpandedLoading(false);
    }
  }

  const araToplam = kalemler.reduce((s, k) => s + kalemTutar(k), 0);
  const genelToplam = kalemler.reduce((s, k) => s + kalemKdvli(k), 0);
  const kdvToplam = genelToplam - araToplam;

  const firsatSecenekleri = firsatlar.filter((f) => f.FirmaID === header.firma_id);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      {stokModalIdx !== null && (
        <StokSecici stoklar={stoklar} onSelect={handleStokSecildi} onClose={() => setStokModalIdx(null)} />
      )}

      {msg && (
        <div style={{
          padding: "11px 16px", borderRadius: 8, fontSize: 13, fontWeight: 500,
          background: msg.type === "error" ? "#3f1515" : "#0f3d20",
          border: `1px solid ${msg.type === "error" ? "#dc2626" : "#16a34a"}`,
          color: msg.type === "error" ? "#fca5a5" : "#86efac",
        }}>{msg.text}</div>
      )}

      <div style={card}>
        <div style={{ fontSize: 14, fontWeight: 600, color: "var(--accent-text)", marginBottom: 4 }}>
          {editId ? "Teklif Duzenle" : "Yeni Teklif Olustur"}
        </div>
        <div style={{ fontSize: 11, color: "var(--text-faint)", marginBottom: 16 }}>
          Bu teklif sadece CRM icinde takip edilir. Onaylandiktan sonra Netsis'in kendi teklif ekranindan girilmelidir.
        </div>
        <form onSubmit={handleSubmit}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(160px,1fr))", gap: 12, marginBottom: 16 }}>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>FIRMA</div>
              <select style={inp} value={header.firma_id} required
                onChange={(e) => setHeader({ ...header, firma_id: e.target.value, kisi_id: "", firsat_id: "" })}>
                <option value="">Secin...</option>
                {firmalar.map((f) => <option key={f.CARI_KOD} value={f.CARI_KOD}>{f.Unvan}</option>)}
              </select>
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>KISI</div>
              <select style={inp} value={header.kisi_id} onChange={(e) => setHeader({ ...header, kisi_id: e.target.value })}>
                <option value="">Yok</option>
                {kisiler.map((k) => <option key={k.ID} value={k.ID}>{k.AdSoyad}</option>)}
              </select>
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>ILGILI FIRSAT</div>
              <select style={inp} value={header.firsat_id} onChange={(e) => setHeader({ ...header, firsat_id: e.target.value })}>
                <option value="">Yok</option>
                {firsatSecenekleri.map((f) => <option key={f.ID} value={f.ID}>{f.Baslik}</option>)}
              </select>
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>TARIH</div>
              <input style={inp} type="date" value={header.tarih}
                onChange={(e) => setHeader({ ...header, tarih: e.target.value })} />
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>GECERLILIK TARIHI</div>
              <input style={inp} type="date" value={header.gecerlilik_tarihi}
                onChange={(e) => setHeader({ ...header, gecerlilik_tarihi: e.target.value })} />
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>SORUMLU</div>
              <select style={inp} value={header.sorumlu_kullanici}
                onChange={(e) => setHeader({ ...header, sorumlu_kullanici: e.target.value })}>
                <option value="">Secilmedi</option>
                {plasiyerler.map((p) => <option key={p.PLASIYER_KODU} value={p.Ad}>{p.Ad}</option>)}
              </select>
            </div>
            <div style={{ gridColumn: "1 / -1" }}>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>NOTLAR</div>
              <input style={inp} value={header.notlar}
                onChange={(e) => setHeader({ ...header, notlar: e.target.value })} />
            </div>
          </div>

          <div style={{ fontSize: 12, fontWeight: 600, color: "var(--text-muted)", marginBottom: 8, textTransform: "uppercase", letterSpacing: ".05em" }}>Kalemler</div>
          <div style={{ ...card, background: "var(--bg-card)", padding: 0, overflow: "hidden", marginBottom: 12 }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ background: "var(--bg-sidebar)" }}>
                  {["Stok Kodu", "Aciklama", "Miktar", "Birim Fiyat", "Iskonto %", "KDV %", "Tutar", ""].map((h) => (
                    <th key={h} style={{ ...th, padding: "8px 10px" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {kalemler.map((k, i) => (
                  <tr key={i}>
                    <td style={{ ...td, padding: 6, width: 130 }}>
                      <div style={{ display: "flex", gap: 4 }}>
                        <input style={{ ...inp, padding: "6px 9px" }} value={k.stok_kodu} readOnly
                          placeholder="Secilmedi" />
                        <button type="button" onClick={() => setStokModalIdx(i)}
                          style={{ background: "var(--accent-bg)", border: "1px solid var(--border)", borderRadius: 6, color: "var(--accent-text)", padding: "0 8px", cursor: "pointer", fontSize: 13, flexShrink: 0 }}
                          title="Stok Sec">🔍</button>
                      </div>
                    </td>
                    <td style={{ ...td, padding: 6, minWidth: 200 }}>
                      <input style={{ ...inp, padding: "6px 9px" }} value={k.aciklama}
                        onChange={(e) => updateKalem(i, "aciklama", e.target.value)} />
                    </td>
                    <td style={{ ...td, padding: 6, width: 90 }}>
                      <input style={{ ...inp, padding: "6px 9px" }} type="number" step="0.001" value={k.miktar}
                        onChange={(e) => updateKalem(i, "miktar", e.target.value)} />
                    </td>
                    <td style={{ ...td, padding: 6, width: 110 }}>
                      <input style={{ ...inp, padding: "6px 9px" }} type="number" step="0.01" value={k.birim_fiyat}
                        onChange={(e) => updateKalem(i, "birim_fiyat", e.target.value)} />
                    </td>
                    <td style={{ ...td, padding: 6, width: 80 }}>
                      <input style={{ ...inp, padding: "6px 9px" }} type="number" step="0.01" value={k.iskonto_orani}
                        onChange={(e) => updateKalem(i, "iskonto_orani", e.target.value)} />
                    </td>
                    <td style={{ ...td, padding: 6, width: 80 }}>
                      <input style={{ ...inp, padding: "6px 9px" }} type="number" step="0.01" value={k.kdv_orani}
                        onChange={(e) => updateKalem(i, "kdv_orani", e.target.value)} />
                    </td>
                    <td style={{ ...td, padding: "6px 10px", textAlign: "right", fontWeight: 600, color: "#34d399" }}>
                      {fmt(kalemKdvli(k))}
                    </td>
                    <td style={{ ...td, padding: 6 }}>
                      <button type="button" onClick={() => removeKalemRow(i)}
                        style={{ background: "#3f1515", color: "#fca5a5", border: "1px solid #7f1d1d", borderRadius: 6, padding: "4px 9px", fontSize: 11, cursor: "pointer" }}>
                        Sil
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div style={{ padding: 10 }}>
              <button type="button" onClick={addKalemRow} style={btn("var(--accent-bg)", "var(--accent-text)")}>+ Kalem Ekle</button>
            </div>
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 24, marginBottom: 16, fontSize: 13 }}>
            <div>Ara Toplam: <strong style={{ color: "var(--text-primary)" }}>{fmt(araToplam)}</strong></div>
            <div>KDV: <strong style={{ color: "var(--text-primary)" }}>{fmt(kdvToplam)}</strong></div>
            <div>Genel Toplam: <strong style={{ color: "#34d399", fontSize: 15 }}>{fmt(genelToplam)}</strong></div>
          </div>

          <div style={{ display: "flex", gap: 10 }}>
            <button type="submit" style={btn("var(--accent)", "#fff")}>{editId ? "Guncelle" : "Teklif Olustur"}</button>
            {editId && (
              <button type="button" onClick={resetForm} style={btn("var(--border)", "var(--text-secondary)")}>Iptal</button>
            )}
          </div>
        </form>
      </div>

      <div style={{ ...card, padding: 0, overflow: "hidden" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "var(--bg-sidebar)" }}>
              {["Teklif No", "Firma", "Tarih", "Gecerlilik", "Toplam (KDV Dahil)", "Durum", "Netsis", ""].map((h) => (
                <th key={h} style={th}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={8} style={{ ...td, textAlign: "center", color: "var(--text-faint)", padding: 32 }}>Yukleniyor...</td></tr>}
            {!loading && teklifler.length === 0 && <tr><td colSpan={8} style={{ ...td, textAlign: "center", color: "var(--text-faint)", padding: 32 }}>Henuz teklif olusturulmamis.</td></tr>}
            {teklifler.map((t) => { const rowKey = t.ID ?? t.NetsisFatirsNo; return (
              <Fragment key={rowKey}>
              <tr
                onMouseEnter={(e) => e.currentTarget.style.background = "var(--bg-card-alt)"}
                onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}>
                <td style={{ ...td, color: "#60a5fa", fontWeight: 600 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                    <button type="button" onClick={() => handleToggleExpand(t)}
                      style={{ background: "none", border: "none", color: "var(--text-faint)", cursor: "pointer", fontSize: 11, padding: 0 }}
                      title="Kalemleri goster">
                      {expandedKey === rowKey ? "▾" : "▸"}
                    </button>
                    <div>
                      {t.TeklifNo}
                      {t.Kaynak === "Netsis" && (
                        <div style={{ fontSize: 10, fontWeight: 400, color: "var(--text-faint)" }}>Netsis kaydi</div>
                      )}
                    </div>
                  </div>
                </td>
                <td style={td}>{t.FirmaUnvani}</td>
                <td style={{ ...td, color: "var(--text-secondary)" }}>{String(t.Tarih).slice(0, 10)}</td>
                <td style={{ ...td, color: "var(--text-secondary)" }}>{t.GecerlilikTarihi ? String(t.GecerlilikTarihi).slice(0, 10) : "-"}</td>
                <td style={{ ...td, textAlign: "right", fontWeight: 600 }}>{fmt(t.ToplamKdvli)}</td>
                <td style={td}>
                  {t.Kaynak === "CRM" ? (
                    <select
                      value={t.Durum}
                      onChange={(e) => handleDurumChange(t.ID, e.target.value)}
                      style={{
                        padding: "4px 8px", borderRadius: 99, fontSize: 11, fontWeight: 600, border: "none", cursor: "pointer",
                        background: "var(--bg-card)", color: DURUM_RENK[t.Durum] || "var(--text-secondary)",
                      }}
                    >
                      {DURUMLAR.map((d) => <option key={d} value={d}>{d}</option>)}
                    </select>
                  ) : (
                    <span style={{ color: "var(--text-faint)", fontSize: 12 }}>—</span>
                  )}
                </td>
                <td style={td}>
                  {t.NetsisFatirsNo ? (
                    <span title={t.NetsisGonderimTarihi ? String(t.NetsisGonderimTarihi).slice(0, 16).replace("T", " ") : ""}
                      style={{ padding: "3px 9px", borderRadius: 99, fontSize: 11, fontWeight: 600, background: "#0d3b2e", color: "#34d399" }}>
                      ✓ {t.NetsisFatirsNo}
                    </span>
                  ) : (
                    <button onClick={() => handleNetsisGonder(t.ID, t.TeklifNo)}
                      disabled={netsisLoadingId === t.ID}
                      style={{
                        background: netsisLoadingId === t.ID ? "var(--border)" : "#1e1b4b",
                        color: netsisLoadingId === t.ID ? "var(--text-faint)" : "#a5b4fc",
                        border: "1px solid #4338ca", borderRadius: 6, padding: "4px 10px", fontSize: 11,
                        cursor: netsisLoadingId === t.ID ? "not-allowed" : "pointer",
                      }}>
                      {netsisLoadingId === t.ID ? "Gonderiliyor..." : "Netsis'e Gonder"}
                    </button>
                  )}
                </td>
                <td style={{ ...td, display: "flex", gap: 6 }}>
                  <button onClick={() => handlePrint(t)}
                    style={{ background: "var(--bg-card)", color: "var(--text-secondary)", border: "1px solid var(--border)", borderRadius: 6, padding: "4px 10px", fontSize: 11, cursor: "pointer" }}>
                    🖨️ Yazdır
                  </button>
                  {t.Kaynak === "CRM" ? (
                    <>
                      <button onClick={() => handleEdit(t)}
                        style={{ background: "var(--accent-bg)", color: "var(--accent-text)", border: "none", borderRadius: 6, padding: "4px 10px", fontSize: 11, cursor: "pointer" }}>
                        Duzenle
                      </button>
                      <button onClick={() => handleDelete(t.ID, t.TeklifNo)}
                        style={{ background: "#3f1515", color: "#fca5a5", border: "1px solid #7f1d1d", borderRadius: 6, padding: "4px 10px", fontSize: 11, cursor: "pointer" }}>
                        Sil
                      </button>
                    </>
                  ) : (
                    <span style={{ color: "var(--text-faint)", fontSize: 12 }}>—</span>
                  )}
                </td>
              </tr>
              {expandedKey === rowKey && (
                <tr>
                  <td colSpan={8} style={{ ...td, padding: 0, background: "var(--bg-page)" }}>
                    {expandedLoading ? (
                      <div style={{ padding: 16, textAlign: "center", color: "var(--text-faint)", fontSize: 12 }}>Yukleniyor...</div>
                    ) : expandedKalemler.length === 0 ? (
                      <div style={{ padding: 16, textAlign: "center", color: "var(--text-faint)", fontSize: 12 }}>Kalem bulunamadi.</div>
                    ) : (
                      <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                          <tr>
                            {["Stok Kodu", "Aciklama", "Miktar", "Birim Fiyat", "KDV %", "Tutar"].map((h) => (
                              <th key={h} style={{ ...th, padding: "6px 14px", fontSize: 10 }}>{h}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {expandedKalemler.map((k, i) => (
                            <tr key={i}>
                              <td style={{ ...td, padding: "6px 14px", fontSize: 12, color: "var(--text-secondary)" }}>{k.StokKodu || "-"}</td>
                              <td style={{ ...td, padding: "6px 14px", fontSize: 12 }}>{k.Aciklama}</td>
                              <td style={{ ...td, padding: "6px 14px", fontSize: 12 }}>{k.Miktar}</td>
                              <td style={{ ...td, padding: "6px 14px", fontSize: 12 }}>{fmt(k.BirimFiyat)}</td>
                              <td style={{ ...td, padding: "6px 14px", fontSize: 12 }}>{k.KdvOrani}</td>
                              <td style={{ ...td, padding: "6px 14px", fontSize: 12, fontWeight: 600, color: "#34d399" }}>
                                {fmt((k.Miktar || 0) * (k.BirimFiyat || 0) * (1 - (k.IskontoOrani || 0) / 100))}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </td>
                </tr>
              )}
              </Fragment>
            ); })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
